import request from "../utils/request"



export function upgradeToBasicPlan() {
  return request.post(`api/charge/create?plan=1`)
}